import { render, staticRenderFns } from "./quotations.vue?vue&type=template&id=27dbe8ef&scoped=true"
import script from "./quotations.vue?vue&type=script&lang=js"
export * from "./quotations.vue?vue&type=script&lang=js"
import style0 from "./quotations.vue?vue&type=style&index=0&id=27dbe8ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dbe8ef",
  null
  
)

export default component.exports